export default "__VITE_ASSET__HyZNEO02__"